import React from 'react';

import api from '../../../../services';

import AutoComplete from 'material-ui/AutoComplete';

class BuilderYard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            yards: [],
        };

        this.changeAutoComplete = this.changeAutoComplete.bind(this);
        this.chooseAutoComplete = this.chooseAutoComplete.bind(this);
    }

    changeAutoComplete(searchText) {
        this.props.changeField({
            field: 'builderV2.yard.name',
            value: searchText,
        });

        this.setState({
            yards: [],
        }, () => {
            if (searchText) {
                api.findYards(searchText)
                    .then((response) => {
                        if (response.status === 200) {
                            const yards = response.data.data.map(yard => ({
                                name: yard.name,
                                yard,
                            }));

                            if (!yards.length) {
                                this.setState({
                                    yards: [],
                                });

                                this.props.changeField({
                                    field: 'builderV2.yard._id',
                                    value: '',
                                });
                            } else {
                                this.setState({
                                    yards,
                                });
                            }
                        }
                    })
                    .catch((error) => {
                        console.error('Error AutoComplete Yards - Builder component', error);
                        return null;
                    });
            } else {
                this.props.changeField({
                    field: 'builderV2.yard._id',
                    value: '',
                });
            }
        });
    }

    chooseAutoComplete(updateProperties) {
        this.setState({
            name: '',
            yards: [],
        });

        this.props.changeField({
            field: 'builderV2.yard',
            value: updateProperties.yard,
        });
    }

    render() {
        const {  yards } = this.state;
        const { getError, confirmed, yard, modifiedFields, underStyle } = this.props;

        return (
            <AutoComplete
                name='yard'
                disabled={confirmed}
                floatingLabelText='Yard'
                searchText={yard && yard.name || ''}
                dataSource={yards}
                dataSourceConfig={{ text: 'name', value: 'yard' }}
                onUpdateInput={this.changeAutoComplete}
                onNewRequest={this.chooseAutoComplete}
                filter={AutoComplete.noFilter}
                errorText={getError('yard')}
                listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                popoverProps={{
                    canAutoPosition: true,
                }}
                fullWidth

                underlineStyle={modifiedFields && modifiedFields.includes('builderV2.yard.name') ? underStyle : null}
            />
        );
    }
}

export default BuilderYard;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/BuilderYard.jsx